import React from 'react';
import { connect } from 'react-redux';
import DataSnapshot from '../../aylaTimeZone/AylaTimeZone';
import FilterPanel, { oem_id } from '../../filters/filterPanel/FilterPanel';
import FunelChart from '../../reports/funnelChartReport/FunnelChartReport';
import ReportPage from '../ReportPage';
import TitleBar from '../../titleBar/TitleBar';
import {AYLA_ALLOWED_ROLES, GoogleAnalyticsConstants} from '../../../constants';
import {
  activatedDevices, activatedDevicesLeft, activatedDevicesRight,
  averageDaysToActivationLeft, averageDaysToActivationRight,
  devicesOnlineToday, listOfOems, percentageOfActiveDevicesLeft,
  percentageOfActiveDevicesRight, percentageOfRegisteredDevicesLeft, percentageOfRegisteredDevicesRight,
  totalDatapoints, contractTotalDatapointsTransactions,
} from '../../../services/reportsservice';
import {logPageViewEvent} from "../../../services/analyticsservice";
import {getErrorReportNames, getReportData} from "../../../helpers/utils";

class OnboardingAnalysisPage extends ReportPage {
  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.OnboardingAnalysisPage.title, logged_in_oem_id);
  }
  reports() {
    const filters = this.props.presistFilters;
    const leftFilters = {
      ...this.props.presistFilters,
      end_date: this.props.presistFilters.left_end_date,
      start_date: this.props.presistFilters.left_start_date,
    };

    const rightFilters = {
      ...this.props.presistFilters,
      end_date: this.props.presistFilters.right_end_date,
      start_date: this.props.presistFilters.right_start_date,
    };
    const isUsFieldDpMeteringOem = (this.props.presistFilters.region_name === 'US-FIELD'
      && this.us_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isEuFieldDpMeteringOem = (this.props.presistFilters.region_name === 'EU'
        && this.eu_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
      const isSharkVpc = (((this.props.presistFilters.region_name === 'US-VPC') || (this.props.presistFilters.region_name === 'EU'))
          && this.props.presistFilters.oem_id === '39a9391a');

    return {
      filters: [
        listOfOems(leftFilters),
      ],
      reports:(isUsFieldDpMeteringOem || isEuFieldDpMeteringOem || isSharkVpc) ? [
            activatedDevices(filters),
            contractTotalDatapointsTransactions(filters),
            devicesOnlineToday(filters),

            activatedDevicesLeft(leftFilters),
            percentageOfRegisteredDevicesLeft(leftFilters),
            percentageOfActiveDevicesLeft(leftFilters),
            averageDaysToActivationLeft(leftFilters),

            activatedDevicesRight(rightFilters),
            percentageOfRegisteredDevicesRight(rightFilters),
            percentageOfActiveDevicesRight(rightFilters),
            averageDaysToActivationRight(rightFilters),
          ]
        : [
        activatedDevices(filters),
        totalDatapoints(filters),
        devicesOnlineToday(filters),

        activatedDevicesLeft(leftFilters),
        percentageOfRegisteredDevicesLeft(leftFilters),
        percentageOfActiveDevicesLeft(leftFilters),
        averageDaysToActivationLeft(leftFilters),

        activatedDevicesRight(rightFilters),
        percentageOfRegisteredDevicesRight(rightFilters),
        percentageOfActiveDevicesRight(rightFilters),
        averageDaysToActivationRight(rightFilters),
      ],
    };
  }

  render() {
    const { fetchData, errors, session } = this.props;
    if(errors.length > 0) getErrorReportNames(errors);

    return (
      <div className="OnboardingAnalysisPage page">
        <TitleBar title="onboardingAnalysis">
          <DataSnapshot snapShot={this.dataSnapshotTime} />
        </TitleBar>
        <div className="pageContent">
          <FilterPanel disabled={fetchData.fetches > 0}
            currentFilters={this.props.presistFilters}
            filters={[
              AYLA_ALLOWED_ROLES.includes(session.role) && oem_id(this.report(listOfOems)),
            ]}
          />

          <div>
            <FunelChart title="devices.allByStatus"
              leftTimerange={this.props.presistFilters}
              rightTimerange={this.props.presistFilters}
              leftTotal={getReportData(this.report(activatedDevicesLeft),
                'Onboarding_Analysis_Activated_Devices')}
              rightTotal={getReportData(this.report(activatedDevicesRight),
                'Onboarding_Analysis_Activated_Devices')}
              totalLabel="activated"
              disabled={fetchData.fetches > 0}
              data={{
                left: [{
                  key: 'registered',
                  value: getReportData(this.report(percentageOfRegisteredDevicesLeft),
                    'Onboarding_Analysis_Percentage_Registered_Devices'),
                }],
                right: [{
                  key: 'registered',
                  value: getReportData(this.report(percentageOfRegisteredDevicesRight),
                    'Onboarding_Analysis_Percentage_Registered_Devices'),
                }],
              }}
              extraInfo={[
                {
                  key: 'averageDaysToActivation',
                  left: getReportData(this.report(averageDaysToActivationLeft),
                    'Average_Days_To_Activation', 'stringToNumberLocale'),
                  right: getReportData(this.report(averageDaysToActivationRight),
                    'Average_Days_To_Activation', 'stringToNumberLocale'),
                },
                {
                  key: 'active',
                  left: getReportData(this.report(percentageOfActiveDevicesLeft),
                    'Onboarding_Analysis_Percentage_Active','stringToPercentage'),
                  right: getReportData(this.report(percentageOfActiveDevicesRight),
                    'Onboarding_Analysis_Percentage_Active','stringToPercentage'),
                },
              ]}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(OnboardingAnalysisPage);
